module.exports = common;